import { buildEntityLinks } from '@griply/utils';
import { useMemo } from 'react';
import { useRelationships } from 'shared/hooks/use-relationships';

// Built once per relationships change — resolving links per goal per render turns the goal buckets O(n²).
export const useEntityLinks = () => {
  const relationships = useRelationships();

  return useMemo(() => buildEntityLinks(relationships), [relationships]);
};
